import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import TaskInput from "TaskDialogCommon/TaskInput";
import _ from "lodash";
import UserDataService from "service/UserDataService";
import { DialogButton } from "Common/DialogButton";

export default function(props) {
  const { email } = props;
  const [server, setServer] = React.useState(null);

  const validate = () => {
    if (server === null || server === "") {
      alert("Please provide a valid server.");
      return false;
    }
    return true;
  };

  const onSubmit = () => {
    if (!validate()) {
      return;
    }
    UserDataService.addServerToAccount({ email }, server);
  };

  return (
    <TaskDialog heading={"Add Server"}>
      <TaskInput
        label="Server"
        placeholder="Example: 257"
        value={server}
        onChange={(event) => {
          setServer(event.target.value);
        }}
      />
      <DialogButton onClick={onSubmit} label="Add" />
    </TaskDialog>
  );
}
